// @flow @format

class Client {
	_headers: Headers;
	_baseUrl: string;

	constructor(baseUrl: string, headers: Headers) {
		this._headers = headers;
		this._baseUrl = baseUrl;
	}

	do(req: Request): Promise<Response> {
		for (let [key, val] of this._headers.entries()) {
			req.headers.set(key, val);
		}

		return fetch(req);
	}

	get(path: string): Promise<Response> {
		return this.do(new Request(this._baseUrl + path, {method: 'GET'}));
	}

	head(path: string): Promise<Response> {
		return this.do(new Request(this._baseUrl + path, {method: 'HEAD'}));
	}

	post(
		path: string,
		contentType: string,
		body: Blob | FormData | URLSearchParams | string,
	): Promise<Response> {
		const req = new Request(this._baseUrl + path, {
			method: 'POST',
			body: body,
			headers: {'Content-Type': contentType},
		});

		return this.do(req);
	}

	put(
		path: string,
		contentType: string,
		body: Blob | FormData | URLSearchParams | string,
	): Promise<Response> {
		const req = new Request(this._baseUrl + path, {
			method: 'PUT',
			body: body,
			headers: {'Content-Type': contentType},
		});
		return this.do(req);
	}

	patch(
		path: string,
		contentType: string,
		body: Blob | FormData | URLSearchParams | string,
	): Promise<Response> {
		const req = new Request(this._baseUrl + path, {
			method: 'PATCH',
			body: body,
			headers: {'Content-Type': contentType},
		});
		return this.do(req);
	}
}

export default Client;



// WEBPACK FOOTER //
// ./src/lib/client/index.js